import React, { useState, useEffect } from 'react';
import Sidebar from './Sidebar';
import { Button, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Container } from 'reactstrap';
import { useAuth } from '../../auth/AuthContext';

const MainLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { user, logout } = useAuth();

  // Tancar sidebar per defecte en mòbil
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setIsSidebarOpen(false);
      } else {
        setIsSidebarOpen(true);
      }
    };
    
    // Executar en carregar
    handleResize();
    
    // Escoltar canvis de mida
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  return (
    <div id="layout-wrapper">
        
        {/* Header - Fixed Top */}
        <header id="page-topbar">
            <div className="navbar-header">
                <div className="d-flex align-items-center">
                     {/* Always functional Toggle Button - Professional Arrow Style */}
                     <Button 
                        color="none" 
                        onClick={toggleSidebar} 
                        className="px-3 font-size-24 header-item waves-effect border-0"
                        title="Alternar Menú"
                     >
                        <i className={`bi ${isSidebarOpen ? 'bi-arrow-bar-left' : 'bi-arrow-bar-right'} text-dark fs-4`}></i>
                     </Button>

                    {/* Page Title */}
                    <h4 className="mb-0 font-size-18 text-dark fw-bold ms-2">
                        Series en Familia
                    </h4>
                </div>

                <div className="d-flex align-items-center">
                    {/* Search Icon Placeholder (Mobile) or Notifications could go here */}

                    {/* User Profile Dropdown */}
                    <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown} className="d-inline-block ms-3 me-3">
                        <DropdownToggle tag="button" className="btn header-item waves-effect d-flex align-items-center border-0 bg-transparent" id="page-header-user-dropdown">
                            {/* Avatar placeholder - Initials if no image */}
                            <div className="rounded-circle bg-soft-primary text-primary dh-avatar d-flex justify-content-center align-items-center fw-bold me-2" style={{width: '36px', height: '36px'}}>
                                {user?.name ? user.name.charAt(0).toUpperCase() : 'U'}
                            </div>
                            <span className="d-none d-xl-inline-block ms-1 fw-medium font-size-15 text-dark">
                                {user ? user.name : 'Usuario'}
                            </span>
                            <i className="bi bi-chevron-down d-none d-xl-inline-block ms-2 font-size-12 text-muted"></i>
                        </DropdownToggle>
                        <DropdownMenu end className="shadow-lg border-0">
                            <DropdownItem header>Benvingut, {user?.name}</DropdownItem>
                            <DropdownItem href="#"><i className="bi bi-person me-2 align-middle"></i> Perfil</DropdownItem>
                            <DropdownItem href="#"><i className="bi bi-gear me-2 align-middle"></i> Configuració</DropdownItem>
                            <DropdownItem divider />
                            <DropdownItem onClick={logout} className="text-danger">
                                <i className="bi bi-box-arrow-right me-2 align-middle"></i> Tancar Sessió
                            </DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                </div>
            </div>
        </header>

        {/* Sidebar overlay per a mòbil */}
        {isSidebarOpen && (
            <div 
                className="sidebar-overlay" 
                onClick={toggleSidebar}
            ></div>
        )}

        {/* Sidebar Component */}
        <Sidebar isOpen={isSidebarOpen} toggle={toggleSidebar} />

        {/* Content Area */}
        <div className={`main-content ${isSidebarOpen ? 'sidebar-open' : 'sidebar-closed'}`}>
            <div className="page-content">
                <Container fluid>
                    {children}
                </Container>
            </div>
            
            {/* Footer */}
            <footer className="footer">
                <Container fluid>
                    <div className="row">
                        <div className="col-12 text-center text-sm-end">
                            {new Date().getFullYear()} © Series Dashboard
                        </div>
                    </div>
                </Container>
            </footer>
        </div>
    </div>
  );
};

export default MainLayout;
